import { localStorageService } from "@Engage.Data/services/storage/localStorage/LocalStorageService";
import { CookiesStorageService } from "@Engage.Data/services/storage/cookies/CookiesStorageService";
import { StorageKeys, CookiesKeys } from "@Engage.Data/constants/Constants";
import { UserDataModel } from "./UserDataModel";
import { DataEncryptor } from "@Core/utils/DataEncryptor";
export class UserStore {
    static setUser(user) {
        UserStore._user = user;
    }
    static warmCache() {
        if (!UserStore._user) {
            UserStore.getUser();
        }
    }
    static getUser() {
        if (UserStore._user)
            return UserStore._user;
        const raw = this.readRaw();
        if (!raw)
            return null;
        let parsed = null;
        try {
            parsed = DataEncryptor.decrypt(raw);
        }
        catch (_a) { }
        if (!parsed) {
            try {
                parsed = JSON.parse(raw);
            }
            catch (_b) {
                return null;
            }
        }
        if (!parsed)
            return null;
        UserStore._user = new UserDataModel(parsed);
        return UserStore._user;
    }
    static clearUser() {
        UserStore._user = null;
        // Clear both plain and expanded localStorage keys
        localStorageService.delete(StorageKeys.ConnextUserData, { expandKey: false });
        localStorageService.delete(StorageKeys.ConnextUserData, { expandKey: true });
    }
    static isLoggedIn() {
        const user = this.getUser();
        return !!(user && user.UserState && user.UserState !== "LoggedOut");
    }
    /**
     * Reads raw encrypted user data from all possible storage locations,
     * matching every combination Connext v2 and the SDK may have written:
     *
     * 1. localStorage, expandKey: false  → key: "Connext_UserData"           (SDK write)
     * 2. localStorage, expandKey: true   → key: "Connext_UserData_SITE_CFG_ENV" (v2 write)
     * 3. cookie, expandKey: false        → key: "sub_Connext_UserData"        (SDK cookie write)
     * 4. cookie, expandKey: true         → key: "sub_Connext_UserData_SITE_CFG_ENV" (v2 cookie write)
     */
    static readRaw() {
        // 1. Cookie plain key (SDK cookie write via CookiesKeys.UserData)
        const c1 = CookiesStorageService.get(CookiesKeys.UserData, { expandKey: false });
        if (c1 && typeof c1 === 'string')
            return c1;
        // 2. Cookie expanded key (Connext v2 cookie write)
        const c2 = CookiesStorageService.get(CookiesKeys.UserData, { expandKey: true });
        if (c2 && typeof c2 === 'string')
            return c2;
        // 3. localStorage plain key (SDK writes this)
        const ls1 = localStorageService.get(StorageKeys.ConnextUserData, { expandKey: false, isJson: false });
        if (ls1 && typeof ls1 === 'string' && ls1 !== StorageKeys.ConnextUserData)
            return ls1;
        // 4. localStorage expanded key (Connext v2 writes this)
        const ls2 = localStorageService.get(StorageKeys.ConnextUserData, { expandKey: true, isJson: false });
        if (ls2 && typeof ls2 === 'string' && ls2 !== StorageKeys.ConnextUserData)
            return ls2;
        return null;
    }
}
UserStore._user = null;
